<template>
   <div class="container-mobile">
      <formulaire-ruche mode="create"></formulaire-ruche>
   </div>
</template>

<script>
import FormulaireRuche from "./FormulaireRuche";

export default {
   components: {
      FormulaireRuche
   },
   computed: {
      user() {
         return this.$store.state.user;
      }
   },
   mounted() {
      this.$store.commit("setTitre", "Ajouter une ruche");
      if (this.user.ruches >= 10) {
         if (
            this.user.abonnement == null ||
            (this.user.abonnement &&
               this.user.abonnement.stripe_status != "active")
         ) {
            this.$buefy.dialog.confirm({
               title: "Limite atteinte",
               message:
                  "Vous avez atteint la limite de 10 ruches autorisées dans la version gratuite. Abonnez-vous à BeePerf Premium pour pouvoir continuer à gérer des ruches supplémentaires ou bien supprimez des ruches existantes.",
               cancelText: "Retour",
               confirmText: "S'abonner",
               icon: "information",
               hasIcon: true,
               onConfirm: () => this.$router.push({ name: "abonnement" }),
               onCancel: () => this.$router.push({ name: "ruches" })
            });
         }
      }
   }
};
</script>
